<div class="as-column">
  <div class="as-row as-justify-end">
    <mat-icon
      svgIcon="ic-close-green"
      class="as-pointer"
      mat-dialog-close
    ></mat-icon>
  </div>
  <mat-label
    class="as-font-24 as-roboto-slab as-font-bold as-text-align-center"
  >
    {{
      data?.hideButton || isPointsCheck
        ? 'Tarjeta Club Alsuper'
        : ('PURCHASE.redeemPoints' | translate)
    }}
  </mat-label>
  @if (shared) {
  <div class="as-card-info as-row as-align-center as-justify-end as-gap-10">
    <div class="as-info as-font as-font-10 as-font-w-700">
      {{ 'CLUB.shareClubCard' | translate }}
    </div>
    <mat-icon
      matTooltip="Puedes usar tu tarjeta Club Alsuper con hasta 3 cuentas diferentes."
      [matTooltipPosition]="'below'"
      matTooltipHideDelay="100000"
      svgIcon="ic-question"
    ></mat-icon>
  </div>
  }
  <div class="as-main-column-redeem">
    <div class="as-alsuper-card">
      <mat-icon
        class="as-club-alsuper-logo"
        svgIcon="ic-club-alsuper-logo"
      ></mat-icon>
      <div class="as-column as-align-center card">
        <mat-label class="as-font-14 as-font-w-700 as-font-white as-font">
          {{ card_owner }}
        </mat-label>
        <mat-label class="as-font-12 as-font-w-700 as-font-white as-font card">
          ****{{ card_id?.slice(-4) }}
        </mat-label>
      </div>
    </div>
    <div class="as-points-card">
      <mat-label class="as-font-20 as-font-w-700 as-font-black-gray">
        {{ 'GENERAL.alsuperPoints' | translate }}
      </mat-label>
      @if (points !== undefined) {
      <mat-label class="as-font-32 as-font-w-700 as-font-black-gray as-points">
        {{ points }}
      </mat-label>
      } @else {
      <div class="as-spinner-green">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
      }
      <mat-label class="as-font-14 as-font-grey-cc as-mt-15"
        >{{ 'CLUB.vigence' | translate }} {{ validity }}
      </mat-label>
    </div>

    <!-- REWARDS -->
    @if (data?.hideButton) {
    <div class="as-rewards as-row as-gap-10 as-align-center as-justify-end">
      <p class="as-font as-font-w-700 as-font-white as-font-12">
        {{ 'CLUB.discoverRewards' | translate }}
      </p>
      <mat-icon class="as-arrow" svgIcon="ic-arrow-right"></mat-icon>
    </div>
    }
    <!-- REWARDS -->

    @if (points && !data && !hideButton) {
    <div
      matRipple
      matRippleColor="rgba(126, 197, 67, 0.2)"
      class="as-points-dist as-pointer"
      [class.active]="pointsSelected?.points === 0"
    >
      <mat-label class="as-font-12 as-font-normal">
        {{ 'CLUB.cero' | translate }}
      </mat-label>
      <button
        mat-flat-button
        color="warn"
        class="as-redeem-button"
        (click)="onSelectedPoints(0)"
      >
        <mat-label class="as-font as-font-white as-font-14 as-font-semibold">
          {{ 'PURCHASE.noCanje' | translate }}
        </mat-label>
      </button>
    </div>
    @for ( points of pointsCatalogue.slice( 0, points >= 800 ? 4 : points >= 600
    ? 3 : points >= 400 ? 2 : points >= 200 ? 1 : 0 ) ; track points) {
    <div
      matRipple
      matRippleColor="rgba(126, 197, 67, 0.2)"
      class="as-points-dist as-pointer"
      [class.active]="pointsSelected === points"
    >
      <div class="as-font as-font-12">
        <div>
          <mat-label class="as-font-semibold">
            {{ points.points }}
          </mat-label>
          <mat-label class="as-font-normal">
            {{ 'GENERAL.points' | translate }}
          </mat-label>
        </div>
        <mat-label class="as-font-green as-font-bold">
          -{{ points.percent }}%
        </mat-label>
      </div>
      @if (points && !data && !hideButton) {
      <button
        mat-flat-button
        color="accent"
        class="as-redeem-button"
        (click)="onSelectedPoints(points)"
      >
        <mat-label class="as-font as-font-white as-font-14 as-font-semibold">
          {{ 'PURCHASE.redeem' | translate }}
        </mat-label>
      </button>
      }
    </div>
    } }

    <!-- BUTTONS -->
    @if (!isPointsCheck) {
    <div class="as-buttons as-row as-justify-sb as-align-center as-mt-15">
      <button
        (click)="deleteCard()"
        mat-stroked-button
        class="warn as-font-w-700"
        color="warn"
      >
        {{ 'CLUB.deleteCard' | translate }}
      </button>
      <button
        (click)="updateCard()"
        class="as-font-w-700 as-button-flat"
        mat-flat-button
        color="accent"
      >
        {{ 'CLUB.editCard' | translate }}
      </button>
    </div>
    }
    <!-- BUTTONS -->
  </div>
</div>
